import React from 'react';

interface IProps {
  long?: boolean;
  className?: string;
}

const PointingPath: React.FC<IProps> = ({ long = false, className = '' }) => {
  const viewBox = long ? '0 0 1714.5 971.3' : '0 0 852 560';
  return (
    <svg version="1.1" viewBox={viewBox} className={className}>
      <path
        fill="#D0D1D0"
        d="M43.5,87.5c-23.7,0-43-19.3-43-43s19.3-43,43-43s43,19.3,43,43S67.2,87.5,43.5,87.5z M43.5,5.5
c-21.5,0-39,17.5-39,39s17.5,39,39,39s39-17.5,39-39S65,5.5,43.5,5.5z"
      />
      <path fill="#D0D1D0" d="M57.7,91c-1.1-2.8-2.2-5.6-3.4-8.4l3.7-1.5c1.1,2.8,2.2,5.6,3.3,8.3L57.7,91z" />
      <path fill="#D0D1D0" d="M72.1,124.4c-2.5-5.5-5-11.1-7.4-16.6l3.7-1.6c2.4,5.5,4.9,11.1,7.4,16.5L72.1,124.4z" />
      <path fill="#D0D1D0" d="M88.1,157.1c-2.8-5.3-5.5-10.8-8.2-16.3l3.6-1.8c2.6,5.4,5.4,10.9,8.1,16.2L88.1,157.1z" />
      <path fill="#D0D1D0" d="M105.6,189c-3-5.2-6-10.6-8.9-15.9l3.5-1.9c2.9,5.3,5.9,10.6,8.9,15.8L105.6,189z" />
      <path fill="#D0D1D0" d="M124.6,220.1c-3.3-5.1-6.5-10.2-9.7-15.4l3.4-2.1c3.1,5.1,6.4,10.3,9.6,15.3L124.6,220.1z" />
      <path fill="#D0D1D0" d="M145.1,250.1c-3.5-4.9-7.1-9.9-10.5-14.9l3.3-2.3c3.4,5,6.9,10,10.4,14.8L145.1,250.1z" />
      <path fill="#D0D1D0" d="M167.2,279.1c-3.8-4.7-7.6-9.5-11.2-14.3l3.2-2.4c3.6,4.8,7.4,9.6,11.2,14.3L167.2,279.1z" />
      <path fill="#D0D1D0" d="M190.8,306.8c-4-4.5-8.1-9.1-12-13.7l3-2.6c3.9,4.6,7.9,9.2,11.9,13.6L190.8,306.8z" />
      <path fill="#D0D1D0" d="M215.8,333.3c-4.3-4.3-8.6-8.7-12.7-13.1l2.9-2.7c4.1,4.3,8.4,8.7,12.6,13L215.8,333.3z" />
      <path fill="#D0D1D0" d="M242.2,358.4c-4.5-4.1-9-8.2-13.4-12.4l2.8-2.9c4.3,4.1,8.8,8.3,13.3,12.3L242.2,358.4z" />
      <path fill="#D0D1D0" d="M269.9,382.1c-4.7-3.8-9.4-7.7-14-11.6l2.6-3c4.6,3.9,9.3,7.8,13.9,11.6L269.9,382.1z" />
      <path fill="#D0D1D0" d="M298.8,404.2c-4.9-3.6-9.8-7.2-14.6-10.9l2.4-3.2c4.8,3.6,9.6,7.3,14.5,10.8L298.8,404.2z" />
      <path fill="#D0D1D0" d="M328.9,424.8c-5.1-3.3-10.2-6.7-15.1-10.1l2.3-3.3c4.9,3.4,10,6.8,15.1,10.1L328.9,424.8z" />
      <path fill="#D0D1D0" d="M359.9,443.9c-5.2-3-10.5-6.2-15.6-9.3l2.1-3.4c5.1,3.1,10.3,6.3,15.6,9.3L359.9,443.9z" />
      <path fill="#D0D1D0" d="M391.8,461.4c-5.4-2.8-10.8-5.7-16.1-8.6l1.9-3.5c5.3,2.9,10.6,5.7,16,8.5L391.8,461.4z" />
      <path fill="#D0D1D0" d="M424.6,477.4c-5.5-2.5-11.1-5.1-16.5-7.8l1.8-3.6c5.4,2.6,10.9,5.2,16.4,7.7L424.6,477.4z" />
      <path fill="#D0D1D0" d="M458.1,491.8c-5.6-2.3-11.3-4.6-16.8-7l1.6-3.7c5.5,2.4,11.1,4.7,16.7,7L458.1,491.8z" />
      <path fill="#D0D1D0" d="M492.1,504.6c-5.7-2-11.5-4.1-17.1-6.3l1.4-3.7c5.6,2.1,11.3,4.2,17,6.2L492.1,504.6z" />
      <path fill="#D0D1D0" d="M526.7,516c-5.8-1.8-11.7-3.6-17.4-5.5l1.3-3.8c5.7,1.9,11.5,3.7,17.3,5.5L526.7,516z" />
      <path fill="#D0D1D0" d="M561.8,526c-5.8-1.5-11.8-3.1-17.6-4.8l1.1-3.8c5.8,1.6,11.7,3.2,17.5,4.8L561.8,526z" />
      <path fill="#D0D1D0" d="M597.2,534.5c-5.9-1.3-11.9-2.7-17.8-4.1l0.9-3.9c5.8,1.4,11.8,2.8,17.7,4.1L597.2,534.5z" />
      <path fill="#D0D1D0" d="M632.9,541.6c-6-1.1-12-2.2-17.9-3.4l0.8-3.9c5.9,1.2,11.9,2.3,17.8,3.4L632.9,541.6z" />
      <path fill="#D0D1D0" d="M668.9,547.3c-6-0.8-12-1.7-18-2.7l0.6-3.9c6,1,12,1.9,17.9,2.7L668.9,547.3z" />
      <path fill="#D0D1D0" d="M705.1,551.7c-6-0.6-12.1-1.3-18.1-2l0.5-4c6,0.7,12.1,1.4,18,2L705.1,551.7z" />
      <path fill="#D0D1D0" d="M741.4,554.8c-6-0.4-12.1-0.8-18.2-1.3l0.3-4c6,0.5,12.1,0.9,18.1,1.3L741.4,554.8z" />
      <path fill="#D0D1D0" d="M777.9,556.4c-6-0.1-12.1-0.4-18.2-0.6l0.2-4c6.1,0.3,12.2,0.5,18.2,0.6L777.9,556.4z" />
      <path
        fill="#D0D1D0"
        d="M797.9,556.6l-1.7,0l0-4l1.7,0c5.6,0,11.1-0.1,16.4-0.2l0.1,4C809,556.5,803.5,556.6,797.9,556.6z"
      />
      <path fill="#D0D1D0" d="M832.6,555.8l-0.2-4c5.7-0.3,8.9-0.6,8.9-0.6l0.4,4C841.5,555.2,838.4,555.4,832.6,555.8z" />
      {long && (
        <>
          <path
            fill="#D0D1D0"
            d="M871.8,553.1l-0.1-4c5-0.1,10.1-0.1,15.2-0.1l2.9,0l0,4l-2.9,0C881.8,553,876.7,553,871.8,553.1z"
          />
          <path
            fill="#D0D1D0"
            d="M871.8,553.1l-0.1-4c5-0.1,10.1-0.1,15.2-0.1l2.9,0l0,4l-2.9,0C881.8,553,876.7,553,871.8,553.1z"
          />
          <path fill="#D0D1D0" d="M925.8,553.6c-6-0.2-12.1-0.3-18-0.5l0.1-4c5.9,0.1,12,0.3,18.1,0.5L925.8,553.6z" />
          <path
            fill="#D0D1D0"
            d="M835.9,554.4l-0.3-4c0.1,0,6.5-0.5,18.1-0.9l0.1,4C842.4,553.9,836,554.4,835.9,554.4z"
          />
          <path fill="#D0D1D0" d="M961.7,555.3c-6-0.4-12-0.7-18-1l0.2-4c6,0.3,12,0.6,18,1L961.7,555.3z" />
          <path fill="#D0D1D0" d="M997.6,558c-5.9-0.5-12-1-17.9-1.5l0.3-4c6,0.4,12,0.9,18,1.5L997.6,558z" />
          <path fill="#D0D1D0" d="M1033.4,561.6c-5.9-0.7-11.9-1.3-17.9-1.9l0.4-4c6,0.6,12,1.3,17.9,1.9L1033.4,561.6z" />
          <path
            fill="#D0D1D0"
            d="M1069.1,566.2c-5.9-0.8-11.9-1.7-17.8-2.4l0.5-4c5.9,0.8,12,1.6,17.9,2.4L1069.1,566.2z"
          />
          <path fill="#D0D1D0" d="M1104.6,571.8c-5.9-1-11.9-2-17.7-2.9l0.6-4c5.9,0.9,11.9,1.9,17.8,2.9L1104.6,571.8z" />
          <path
            fill="#D0D1D0"
            d="M1140,578.5c-5.9-1.2-11.8-2.3-17.7-3.4l0.7-3.9c5.9,1.1,11.8,2.3,17.7,3.5L1140,578.5z"
          />
          <path
            fill="#D0D1D0"
            d="M1175.1,586.1c-5.8-1.4-11.7-2.7-17.5-4l0.9-3.9c5.9,1.3,11.8,2.6,17.6,4L1175.1,586.1z"
          />
          <path fill="#D0D1D0" d="M1210,594.9c-5.7-1.5-11.6-3.1-17.4-4.5l1-3.9c5.8,1.5,11.7,3,17.5,4.5L1210,594.9z" />
          <path
            fill="#D0D1D0"
            d="M1244.6,604.8c-5.7-1.7-11.5-3.4-17.2-5.1l1.1-3.8c5.8,1.6,11.6,3.4,17.3,5.1L1244.6,604.8z"
          />
          <path
            fill="#D0D1D0"
            d="M1278.8,615.8c-5.6-1.9-11.4-3.8-17.1-5.7l1.2-3.8c5.7,1.8,11.5,3.8,17.1,5.7L1278.8,615.8z"
          />
          <path fill="#D0D1D0" d="M1312.6,628c-5.6-2.1-11.2-4.2-16.8-6.3l1.4-3.8c5.6,2,11.3,4.2,16.9,6.3L1312.6,628z" />
          <path
            fill="#D0D1D0"
            d="M1345.9,641.5c-5.5-2.3-11.1-4.7-16.6-6.9l1.5-3.7c5.6,2.2,11.2,4.6,16.7,6.9L1345.9,641.5z"
          />
          <path
            fill="#D0D1D0"
            d="M1378.6,656.3c-5.3-2.5-10.8-5.1-16.3-7.5l1.6-3.6c5.5,2.5,11,5,16.4,7.6L1378.6,656.3z"
          />
          <path
            fill="#D0D1D0"
            d="M1410.7,672.4c-5.2-2.8-10.6-5.5-16-8.2l1.8-3.6c5.4,2.7,10.8,5.5,16,8.3L1410.7,672.4z"
          />
          <path
            fill="#D0D1D0"
            d="M1442.1,689.8c-5.1-3-10.4-6-15.6-8.9l1.9-3.5c5.3,2.9,10.5,5.9,15.7,8.9L1442.1,689.8z"
          />
          <path
            fill="#D0D1D0"
            d="M1472.7,708.7c-5-3.2-10.1-6.5-15.2-9.6l2.1-3.4c5.1,3.1,10.2,6.4,15.2,9.6L1472.7,708.7z"
          />
          <path
            fill="#D0D1D0"
            d="M1502.3,728.9c-4.8-3.5-9.7-6.9-14.7-10.3l2.3-3.3c5,3.4,9.9,6.9,14.8,10.4L1502.3,728.9z"
          />
          <path
            fill="#D0D1D0"
            d="M1530.9,750.6c-4.6-3.7-9.4-7.4-14.2-11l2.4-3.2c4.8,3.6,9.6,7.3,14.2,11.1L1530.9,750.6z"
          />
          <path
            fill="#D0D1D0"
            d="M1558.4,773.7c-4.5-3.9-9-7.9-13.6-11.7l2.6-3.1c4.6,3.9,9.2,7.8,13.7,11.8L1558.4,773.7z"
          />
          <path
            fill="#D0D1D0"
            d="M1584.6,798.2c-4.2-4.2-8.6-8.4-12.9-12.4l2.7-2.9c4.4,4.1,8.8,8.3,13,12.5L1584.6,798.2z"
          />
          <path fill="#D0D1D0" d="M1609.4,824c-4-4.4-8.1-8.8-12.3-13.1l2.9-2.8c4.2,4.3,8.3,8.8,12.3,13.2L1609.4,824z" />
          <path
            fill="#D0D1D0"
            d="M1632.9,851.2c-3.8-4.6-7.7-9.2-11.5-13.7l3-2.6c3.9,4.5,7.8,9.2,11.6,13.8L1632.9,851.2z"
          />
          <path
            fill="#D0D1D0"
            d="M1654.8,879.6c-3.5-4.8-7.1-9.6-10.8-14.3l3.2-2.4c3.7,4.7,7.3,9.6,10.8,14.4L1654.8,879.6z"
          />
          <path fill="#D0D1D0" d="M1675.1,909.1c-3.2-5-6.6-10-10-14.9l3.3-2.3c3.4,4.9,6.8,10,10,15L1675.1,909.1z" />
          <path
            fill="#D0D1D0"
            d="M1693.9,939.7c-3-5.2-6-10.3-9.2-15.4l3.4-2.1c3.1,5.1,6.2,10.3,9.2,15.5L1693.9,939.7z"
          />

          <path
            fill="#D0D1D0"
            d="M1710.9,971.3c-2.7-5.3-5.5-10.7-8.3-15.9l3.5-1.9c2.8,5.2,5.7,10.6,8.4,16L1710.9,971.3z"
          />
        </>
      )}
    </svg>
  );
};
export default PointingPath;
